import { render, staticRenderFns } from "./CreateNewFolder.vue?vue&type=template&id=690cb476&scoped=true&"
import script from "./CreateNewFolder.vue?vue&type=script&lang=js&"
export * from "./CreateNewFolder.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewFolder.vue?vue&type=style&index=0&id=690cb476&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690cb476",
  null
  
)

export default component.exports